import React, {Component} from 'react';
import firebase from 'firebase/app';
import 'firebase/auth';
import SignIn from './SigninView';
import SignUp from './SignupView';
import SignInUpNav from './SignInUpNav'
import {Route, Switch} from 'react-router-dom';

export default class Homepage extends Component {
  

  uiConfig = {
    signInOptions: [
      //firebase.auth.EmailAuthProvider.PROVIDER_ID,
      firebase.auth.GoogleAuthProvider.PROVIDER_ID
    ],
    signInFlow: 'popup',
  }

  



  render(){
    //console.log(this.props)
    return (
      <div id="main-content" className="homepage container">
        <span>
          <h2 className="side-header-left">Saving the environment while saving you money.</h2>
          <img className="homepage-img" src={"/img/front_page_hand.png"} alt="Hand holding out a plant" />
        </span>
        <section classsName="container">
          <div className="signin-module">
            <h2>Let's get started!</h2>
            <SignInUpNav/> 
            <Switch>
              <Route exact path='/home' component={ (routerProps) => 
                    (<SignUp {...routerProps} uiConfig={this.uiConfig} signUpCallback={this.props.signUpCallback}/>)}/>
              <Route exact path='/home/login' component={ (routerProps) => 
                    (<SignIn {...routerProps} uiConfig={this.uiConfig} signInCallback={this.props.signInCallback} />)}/>
            </Switch>
          </div>
        </section>

      </div>
    )


  }
}